import HeroSlider from "./components/HeroSlider";
import CategoryNav from "./components/CategoryNav";
import HotContent from "./components/HotContent";
import LatestContent from "./components/LatestContent";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import JsonLd from "@/components/base/JsonLd";
import { getOrganizationSchema, getWebSiteSchema, getWebPageSchema, getFAQSchema } from "@/components/base/SchemaOrg";

const homeBreadcrumbs = [{ name: "首页", url: "https://www.91madou.com/" }];

export default function Home() {
  return (
    <>
      <JsonLd data={getOrganizationSchema()} />
      <JsonLd data={getWebSiteSchema()} />
      <JsonLd data={getWebPageSchema("/", homeBreadcrumbs)} />
      <JsonLd data={getFAQSchema()} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSlider />
        <CategoryNav />
        <HotContent />
        <LatestContent />
      </main>
      <Footer />
    </>
  );
}